import { render, staticRenderFns } from "./AddTagsToFeedModal.vue?vue&type=template&id=16912b23&scoped=true&"
import script from "./AddTagsToFeedModal.vue?vue&type=script&lang=js&"
export * from "./AddTagsToFeedModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTagsToFeedModal.vue?vue&type=style&index=0&id=16912b23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16912b23",
  null
  
)

export default component.exports